import { useEffect, useState, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';

const DynamicPage = () => {
    const { slug } = useParams();
    const { BaseUrl } = useContext(MyContext);
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axios.get(`${BaseUrl}/pages/${slug}`)
            .then(res => {
                if (res.data.status === 'success') {
                    setPage(res.data.data);
                } else {
                    setPage(null);
                }
            })
            .catch(err => {
                console.error("Failed to load dynamic page:", err);
                setPage(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [slug, BaseUrl]);

    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#070715] text-white">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-indigo-500"></div>
            </div>
        );
    }

    if (!page) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-[#070715] text-white px-4">
                <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
                <p className="text-gray-400 mb-8">The page you are looking for does not exist or has been removed.</p>
                <Link to="/" className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg text-white font-semibold transition-colors duration-300">Go to Home</Link>
            </div>
        );
    }

    return (
        <div className="dynamic_page bg-[#070715] min-h-screen text-white">
            {/* Hero Section */}
            <div className="contact-hero relative overflow-hidden bg-cover bg-center" style={{ background: 'linear-gradient(to bottom, #0d0d2b, #070715)' }}>
                <div className="contact-hero-bg"></div>
                <div className="contact-hero-stars"></div>
                <div className="width_container px-4 relative z-10">
                    <motion.div
                        className="text-center pt-[165px] pb-[100px]"
                        initial="hidden"
                        animate="visible"
                        variants={fadeUp}
                    >
                        <nav className="inline-flex items-center gap-2 mb-4 text-[14px] text-gray-400">
                            <Link to="/" className="hover:text-indigo-400 transition-colors">Home</Link>
                            <span>&gt;</span>
                            <span className="text-indigo-300 font-semibold">{page.title}</span>
                        </nav>
                        <h1 className="text-white font-bold text-[36px] sm:text-[48px] leading-tight mb-4">
                            {page.title}
                        </h1>
                    </motion.div>
                </div>
            </div>

            {/* Content Section */}
            <div className="width_container px-6 py-[60px]">
                <motion.div
                    className="max-w-[900px] mx-auto bg-white/5 border border-white/10 rounded-2xl p-6 sm:p-10 shadow-xl backdrop-blur-md"
                    initial="hidden"
                    animate="visible"
                    variants={fadeUp}
                >
                    <div 
                        className="prose prose-invert max-w-none text-gray-300 leading-relaxed text-[16px] dynamic-html-content"
                        dangerouslySetInnerHTML={{ __html: page.content }}
                    />
                </motion.div>
            </div>
        </div>
    );
};

export default DynamicPage;
